import { api, unwrap } from './client';

// Products
// Backend: GET /api/product/list-simple
export async function getProductNamesAll() {
  const res = await api.get('/product/getAllProducts');
  const data = unwrap(res) || [];
  return data.map(p => ({ id: p.id, name: p.productname || p.productName }));
}

// Revenue by product (new endpoint to be created in backend)
// Expected backend path can be changed if needed.
// Backend: GET /api/finance/revenue/dashboard/by-product
// Query params: { productName }
export async function getRevenueByProductFilter(params = {}) {
  if (!params.productName || params.productName === 'ALL') {
    const res = await api.get('/finance/revenue/dashboard');
    return unwrap(res);
  }
  const res = await api.get('/finance/revenue/dashboard/by-product', { params });
  return unwrap(res);
}

